/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { DenomMetadata } from "./metadata";

export const protobufPackage = "dymensionxyz.dymension.rollapp";

export interface GenesisInfo {
  /** checksum used to verify integrity of the genesis file */
  genesisChecksum: string;
  /** unique bech32 prefix */
  bech32Prefix: string;
  /** native_denom is the base denom for the native token */
  nativeDenom:
    | DenomMetadata
    | undefined;
  /** initial_supply is the initial supply of the native token */
  initialSupply: string;
  /** sealed indicates if the fields in this object are no longer updatable */
  sealed: boolean;
  genesisAccounts: GenesisAccounts | undefined;
}

export interface GenesisAccounts {
  accounts: GenesisAccount[];
}

/** GenesisAccount is a struct for the genesis account for the rollapp */
export interface GenesisAccount {
  /** amount of coins to be sent to the genesis address */
  amount: string;
  /** address is a bech-32 address of the genesis account */
  address: string;
}

function createBaseGenesisInfo(): GenesisInfo {
  return {
    genesisChecksum: "",
    bech32Prefix: "",
    nativeDenom: undefined,
    initialSupply: "",
    sealed: false,
    genesisAccounts: undefined,
  };
}

export const GenesisInfo = {
  encode(message: GenesisInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.genesisChecksum !== "") {
      writer.uint32(10).string(message.genesisChecksum);
    }
    if (message.bech32Prefix !== "") {
      writer.uint32(18).string(message.bech32Prefix);
    }
    if (message.nativeDenom !== undefined) {
      DenomMetadata.encode(message.nativeDenom, writer.uint32(26).fork()).ldelim();
    }
    if (message.initialSupply !== "") {
      writer.uint32(34).string(message.initialSupply);
    }
    if (message.sealed === true) {
      writer.uint32(40).bool(message.sealed);
    }
    if (message.genesisAccounts !== undefined) {
      GenesisAccounts.encode(message.genesisAccounts, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GenesisInfo {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.genesisChecksum = reader.string();
          break;
        case 2:
          message.bech32Prefix = reader.string();
          break;
        case 3:
          message.nativeDenom = DenomMetadata.decode(reader, reader.uint32());
          break;
        case 4:
          message.initialSupply = reader.string();
          break;
        case 5:
          message.sealed = reader.bool();
          break;
        case 6:
          message.genesisAccounts = GenesisAccounts.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): GenesisInfo {
    return {
      genesisChecksum: isSet(object.genesisChecksum) ? String(object.genesisChecksum) : "",
      bech32Prefix: isSet(object.bech32Prefix) ? String(object.bech32Prefix) : "",
      nativeDenom: isSet(object.nativeDenom) ? DenomMetadata.fromJSON(object.nativeDenom) : undefined,
      initialSupply: isSet(object.initialSupply) ? String(object.initialSupply) : "",
      sealed: isSet(object.sealed) ? Boolean(object.sealed) : false,
      genesisAccounts: isSet(object.genesisAccounts) ? GenesisAccounts.fromJSON(object.genesisAccounts) : undefined,
    };
  },

  toJSON(message: GenesisInfo): unknown {
    const obj: any = {};
    message.genesisChecksum !== undefined && (obj.genesisChecksum = message.genesisChecksum);
    message.bech32Prefix !== undefined && (obj.bech32Prefix = message.bech32Prefix);
    message.nativeDenom !== undefined
      && (obj.nativeDenom = message.nativeDenom ? DenomMetadata.toJSON(message.nativeDenom) : undefined);
    message.initialSupply !== undefined && (obj.initialSupply = message.initialSupply);
    message.sealed !== undefined && (obj.sealed = message.sealed);
    message.genesisAccounts !== undefined
      && (obj.genesisAccounts = message.genesisAccounts ? GenesisAccounts.toJSON(message.genesisAccounts) : undefined);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<GenesisInfo>, I>>(object: I): GenesisInfo {
    const message = createBaseGenesisInfo();
    message.genesisChecksum = object.genesisChecksum ?? "";
    message.bech32Prefix = object.bech32Prefix ?? "";
    message.nativeDenom = (object.nativeDenom !== undefined && object.nativeDenom !== null)
      ? DenomMetadata.fromPartial(object.nativeDenom)
      : undefined;
    message.initialSupply = object.initialSupply ?? "";
    message.sealed = object.sealed ?? false;
    message.genesisAccounts = (object.genesisAccounts !== undefined && object.genesisAccounts !== null)
      ? GenesisAccounts.fromPartial(object.genesisAccounts)
      : undefined;
    return message;
  },
};

function createBaseGenesisAccounts(): GenesisAccounts {
  return { accounts: [] };
}

export const GenesisAccounts = {
  encode(message: GenesisAccounts, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.accounts) {
      GenesisAccount.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GenesisAccounts {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisAccounts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.accounts.push(GenesisAccount.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): GenesisAccounts {
    return {
      accounts: Array.isArray(object?.accounts) ? object.accounts.map((e: any) => GenesisAccount.fromJSON(e)) : [],
    };
  },

  toJSON(message: GenesisAccounts): unknown {
    const obj: any = {};
    if (message.accounts) {
      obj.accounts = message.accounts.map((e) => e ? GenesisAccount.toJSON(e) : undefined);
    } else {
      obj.accounts = [];
    }
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<GenesisAccounts>, I>>(object: I): GenesisAccounts {
    const message = createBaseGenesisAccounts();
    message.accounts = object.accounts?.map((e) => GenesisAccount.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGenesisAccount(): GenesisAccount {
  return { amount: "", address: "" };
}

export const GenesisAccount = {
  encode(message: GenesisAccount, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.amount !== "") {
      writer.uint32(10).string(message.amount);
    }
    if (message.address !== "") {
      writer.uint32(18).string(message.address);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GenesisAccount {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisAccount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.amount = reader.string();
          break;
        case 2:
          message.address = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): GenesisAccount {
    return {
      amount: isSet(object.amount) ? String(object.amount) : "",
      address: isSet(object.address) ? String(object.address) : "",
    };
  },

  toJSON(message: GenesisAccount): unknown {
    const obj: any = {};
    message.amount !== undefined && (obj.amount = message.amount);
    message.address !== undefined && (obj.address = message.address);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<GenesisAccount>, I>>(object: I): GenesisAccount {
    const message = createBaseGenesisAccount();
    message.amount = object.amount ?? "";
    message.address = object.address ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
